/*-----------------------------------------------------------------
- Home
-----------------------------------------------------------------*/

export default {
    title    : 'Home',
    watch_now: 'Watch Now',
    discover : {
        link: 'Learn more',
    },
    discover_power: {
        unlock_text: 'Unlock the Power of Headless Software',
        button     : 'Get Started Now!',
    },
    articles: {
        title   : 'Latest Articles',
        author  : 'Author',
        see_blog: 'See Blog',
        min_read: 'min read',
    },
};
